import {useCallback} from 'react';

import type {
  FinancialSummaryField,
  IUseFinancialHistorySubStepParams,
  IUseFinancialHistorySubStepResult,
} from '../financials.types';
import {
  lshNormalizeCurrency,
  lshParseCurrency,
  lshSanitizeCurrencyInput,
} from '../financials.utils';

export function lshUseFinancialHistorySubStep({
  setFinancialSummaries,
}: IUseFinancialHistorySubStepParams): IUseFinancialHistorySubStepResult {
  const handleSummaryFieldChange = useCallback(
    (year: number, field: FinancialSummaryField, value: string) => {
      setFinancialSummaries((current) => {
        return current.map((record) => {
          if (record.year !== year) return record;

          if (field === 'notes') {
            return {
              ...record,
              notes: value,
            };
          }

          if (
            field === 'financialYearEnd' ||
            field === 'financialYearEndMonth'
          ) {
            return {
              ...record,
              [field]: value || undefined,
            };
          }

          const sanitised = lshSanitizeCurrencyInput(value);
          const revenue =
            field === 'revenue' ? sanitised : record.revenue || '0';
          const expenses =
            field === 'expenses' ? sanitised : record.expenses || '0';
          const operatingCosts =
            field === 'operatingCosts'
              ? sanitised
              : record.operatingCosts || '0';

          return {
            ...record,
            [field]: sanitised,
            profitLoss: lshNormalizeCurrency(
              lshParseCurrency(revenue) -
                lshParseCurrency(expenses) -
                lshParseCurrency(operatingCosts),
            ),
          };
        });
      });
    },
    [setFinancialSummaries],
  );

  return {
    handleSummaryFieldChange,
  };
}
